import TreeViewSelection from "@/components/Common/TreeViewSelection/TreeViewSelection.vue";
import "./POIFilter.scss";
import cloneDeep from "lodash/cloneDeep";
import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  props: [
    "featureGroups",
    "categoryTypes",
    "regions",
    "cities",
    "filter",
    "isLoading",
    "categoryGroups"
  ],
  components: { TreeViewSelection },
  data: function() {
    return {
      dialog: false,
      operator: "$and",
      query: {
        [this.operator]: []
      },
      defaultQuery: {
        $and: []
      },
      exhibitionEventFilter: [],
      filterOptions: [
        { name: "allen", value: "$and" },
        { name: "mindestens einer", value: "$or" }
      ],
      selectOptions: [
        { name: "Ist", value: "$eq" },
        { name: "Ist nicht", value: "$ne" }
      ],
      selectableFilter: [
        { name: "Typ", value: "categoryType" },
        { name: "Ort", value: "address.city" },
        {
          name: "Region",
          value: "regions"
        },
        { name: "Highlight", value: "highlight" },
        { name: "Aktiv (Veröffentlicht)", value: "active" },
        {
          name: "Kategorie",
          value: "category"
        },
        { name: "Veranstaltung", value: "exhibitions.eventId" },
        { name: "Merkmale", value: "features" }
      ],
      selectedFilter: ["types"],
      featuresDialog: false,
      displayCategoryTreeview: [false],
      displayFeaturesTreeview: [false],
      values: [],
      features: [],
      categorys: [],
      mappedCategoryTypes: [],
      mappedRegions: [],
      deleted: false,
      eventSearch: null,
      foundEvents: [],
      eventsLoading: false
    };
  },
  async mounted() {
    this.query = cloneDeep(this.defaultQuery);
  },
  methods: {
    async updateFilter(reset) {
      if (!reset) await this.validateQuery();
      this.filter.query = this.query;
      this.$emit("applyFilter", this.query);
      if (reset || !this.query[this.operator])
        this.query = { [this.operator]: [] };
    },

    async validateQuery() {
      let deleteableIndexes = [];
      this.query[this.operator].forEach((key, index) => {
        let keyValue = this.firstPropertyOfFirstProperty(key);
        const parsedKey = Object.keys(key)[0];

        if (
          parsedKey === "exhibitions.eventId" &&
          this.exhibitionEventFilter?.length
        ) {
          keyValue = this.exhibitionEventFilter;
          this.query[this.operator][index] = {
            "exhibitions.eventId": {
              $in: keyValue
            }
          };
        } else if (
          parsedKey === "exhibitions.eventId" &&
          !this.exhibitionEventFilter?.length
        ) {
          deleteableIndexes.push(index);
        }
        if (keyValue && (keyValue === "true" || keyValue === "false"))
          this.stringToBoolean(key); //fixes true/false for json
        if (keyValue === undefined || keyValue === "")
          deleteableIndexes.push(index);
      });
      deleteableIndexes = deleteableIndexes.sort(function(a, b) {
        return b - a;
      });
      deleteableIndexes.forEach(i => this.deleteFilter(i));
      if (!this.query[this.operator].length) this.query = {};
    },

    stringToBoolean(filterObj) {
      const key = Object.keys(filterObj)[0];
      filterObj[key][Object.keys(filterObj[key])[0]] = JSON.parse(
        filterObj[key][Object.keys(filterObj[key])[0]]
      );
    },

    setOperator(newOperator) {
      const oldOperator = Object.keys(this.query)[0];
      if (oldOperator !== newOperator) {
        this.query = {
          [newOperator]: this.query[this.operator]
        };
        this.operator = newOperator;
      }
    },

    addFilter() {
      if (this.mappedCategoryTypes.length) {
        this.query[this.operator].push({ categoryType: { $eq: "" } });
        this.values[
          this.query[this.operator].length - 1
        ] = this.mappedCategoryTypes;
      } else {
        this.query[this.operator].push({ highlight: { $eq: "" } });
        this.values[this.query[this.operator].length - 1] = [
          {
            name: "Ja",
            value: "true"
          },
          { name: "Nein", value: false }
        ];
      }
    },
    deleteFilter(index) {
      if (this.query[this.operator].length === 1) {
        this.query = {};
        this.query[this.operator] = [];
        return;
      }
      this.query[this.operator].splice(index, 1);
      this.query[this.operator].forEach((key, index) => {
        this.setItems(key, index);
      });
    },
    setFilterKey(filterObj, newKey, index) {
      const oldKey = Object.keys(filterObj)[0];
      if (oldKey !== newKey) {
        filterObj[newKey] = filterObj[oldKey];
        delete filterObj[oldKey];
      }
      this.setItems(filterObj, index);
    },
    setDbOperator(filterObj, newOperator) {
      const key = Object.keys(filterObj)[0];
      if (
        filterObj[key] === null ||
        filterObj[key] === undefined ||
        typeof filterObj[key] !== "object"
      )
        filterObj[key] = {};

      const oldOperator = Object.keys(filterObj[key])[0];
      if (oldOperator !== newOperator) {
        filterObj[key][newOperator] = filterObj[key][oldOperator];
        delete filterObj[key][oldOperator];
      }
    },
    setValue(filterObj, value) {
      const key = Object.keys(filterObj)[0];
      const operator = Object.keys(filterObj[key])[0];
      filterObj[key][operator] = value;
    },

    getFilterValue(value) {
      if (value === "categoryType") {
        this.mappedCategoryTypes = this.categoryTypes.map(
          type => (type = { name: type.title, value: type._id })
        );
      }
      if (value === "regions") {
        this.mappedRegions = this.regions.map(
          region => (region = { name: region.title, value: region._id })
        );
        this.mappedRegions.forEach((region, index) => {
          if (region.value === "noRegion") this.mappedRegions.splice(index, 1);
        });
      }
    },

    setItems(filterObj, index) {
      const key = Object.keys(filterObj)[0];
      //INFO: Needed to be reactive
      this.query[this.operator].reverse().reverse();
      switch (key) {
        case "categoryType":
          this.values[index] = this.mappedCategoryTypes;
          break;
        case "address.city":
          this.values[index] = this.cities;
          break;
        case "regions":
          this.values[index] = this.mappedRegions;
          break;
        case "highlight":
        case "active":
          this.values[index] = [
            { name: "Ja", value: true },
            { name: "Nein", value: false }
          ];
          break;
        case "category":
          this.displayCategoryTreeview[index] = true;
          break;
        case "features":
          this.displayFeaturesTreeview[index] = true;
          break;
        default:
          this.values[index] = [];
          break;
      }
      // INFO: needed to be reactive
      this.values.reverse().reverse();
    },

    async resetFilter() {
      this.deleted = false;
      this.query = {
        principal: this.$store.state.selectedPrincipal._id
      };
      await this.updateFilter(true);
    },
    async filterForDeletedPois() {
      if (this.deleted) {
        this.query = {
          principal: this.$store.state.selectedPrincipal._id,
          deleted: this.deleted
        };
        this.filter.query = this.query;
        await this.$emit("applyFilter");
      } else await this.resetFilter();
    },
    firstPropertyOfFirstProperty(filterObj) {
      return filterObj[Object.keys(filterObj)[0]][
        Object.keys(filterObj[Object.keys(filterObj)[0]])[0]
      ];
    },

    async updateValue(filterObj, value) {
      const key = Object.keys(filterObj)[0];
      const operator = Object.keys(filterObj[key])[0];
      if (Array.isArray(value)) filterObj[key][operator] = value[0];
      else filterObj[key][operator] = value;
    }
  },
  computed: {
    isAdmin() {
      return this.$store.state.currentUser?.scopes?.includes("role:admin");
    },
    exhibitionEvents() {
      return this.foundEvents;
    }
  },
  watch: {
    async featuresDialog() {
      await this.updateFilter();
    },
    async eventSearch(val) {
      if (this.eventsLoading) return;

      this.eventsLoading = true;

      const headers = getTokenHeader();
      const { data } = await axios.post(
        `${env.events_api_client_url}event/for_calendar`,
        {
          query: {},
          principal_id: this.$store.state.selectedPrincipal.id,
          s: val,
          distinct: true
        },
        { headers }
      );
      if (data?.results?.length) this.foundEvents = data.results;
      this.eventsLoading = false;
    }
  }
};
